import { render, staticRenderFns } from "./ProductionBatchFlow.vue?vue&type=template&id=2e05d368&"
import script from "./ProductionBatchFlow.vue?vue&type=script&lang=js&"
export * from "./ProductionBatchFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports